/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/screen',
        'assets/js/modules/widgets/mailingLists/view/tableView',
        'assets/js/modules/widgets/mailingLists/mailingListItemCollection',
        'assets/js/modules/popup/PopupLight',
        'Handsontable'
    ],
    function($, _, screen, TableView, MailingListItemCollection, { default: Popup }, Handsontable) {
        var PREVIEW_ROWS = 10;

        return TableView.extend({
            columns: [],

            headerSelectTpl: _.template(
                '<select class="mailing-list-item-column-choice" data-column-number="<%= colNumber %>">' +
                    '<option value="">Do Not Include</option>' +
                    '<% _.each(options, function (optionTitle, option) { %>' +
                    '<option value="<%= option %>" <% if (option == selectedOption) { %>selected<% } %>>' +
                    '<%= optionTitle %>' +
                    '</option>' +
                    '<% }); %>' +
                    '</select>'
            ),

            events: {
                'click #mailing-list-columns-submit': 'onColumnsSubmit',
                'change .mailing-list-item-column-choice': 'onColumnChange'
            },

            initialize: function(options) {
                var _this = this;
                this.table = options.table;
                this.columns = _.keys(MailingListItemCollection.titles);

                this.listenTo(this.model, {
                    'change:uploadListLoading': this.updateListLoading,
                    'list:parsingStarted': this.showView,
                    'list:uploaded': this.onListUploaded,
                    'lists:added': function() {
                        _this.popup.close();
                    },
                    'parser:error': function() {
                        _this.popup.close();
                    }
                });

                this.popup = new Popup(this.$el, {
                    width: 1324,
                    height: 500,
                    beforeClose: function() {
                        _this.columns = _.keys(MailingListItemCollection.titles);
                    }
                });
            },

            initHandsontable: function(data) {
                var _this = this;

                // add empty first row, so Handsontable knows about data schema
                if (!data.length) {
                    var cols = [];
                    for (var i = 0; i < this.columns.length; i++) {
                        cols[i] = '';
                    }
                    data.push(cols);
                }
                this.getTableElement().handsontable({
                    data: data,
                    readOnly: true,
                    colWidth: 134,
                    height: 310,
                    minRows: PREVIEW_ROWS,
                    disableVisualSelection: true,
                    colHeaders: function(col) {
                        var selectedColumn;
                        if (_this.columns.length && _this.columns[col]) {
                            selectedColumn = _this.columns[col];
                        }
                        return _this.getColumnChooser(selectedColumn, col);
                    },
                    // for selects in Firefox
                    beforeOnCellMouseDown: function(event, coords) {
                        if (coords.row < 0) {
                            event.stopImmediatePropagation();
                        }
                    }
                });

                Handsontable.dom.addEvent(this.el, 'mousedown', function(e) {
                    if ($(e.target).is('.mailing-list-item-column-choice')) {
                        e.stopImmediatePropagation();
                    }
                });
            },

            getPreviewData: function(data) {
                data = data || [];
                if (data.length > PREVIEW_ROWS) {
                    data = data.slice(0, PREVIEW_ROWS);
                }
                return data;
            },

            showView: function() {
                this.popup.open();
                this.initHandsontable([]);
            },

            onListUploaded: function(data, columns) {
                this.columns = columns;
                this.loadData(this.getPreviewData(_.clone(data)));
            },

            onColumnChange: function(e) {
                var $columnChooser = $(e.target);
                var colNumber = $columnChooser.data('column-number');
                this.columns[colNumber] = $columnChooser.val() || null;
                $columnChooser.focus(); // for IE 11
            },

            onColumnsSubmit: function() {
                this.model.trigger('list:columnsMatch', this.columns);
            },

            getColumnChooser: function(selectedColumn, colNumber) {
                return this.headerSelectTpl({
                    options: MailingListItemCollection.titles,
                    selectedOption: selectedColumn,
                    colNumber: colNumber
                });
            },

            updateListLoading: function() {
                var $loading = this.$el.find('.mailing-list-items-table-overlay');

                if (this.model.get('uploadListLoading')) {
                    $loading.show();
                } else {
                    $loading.hide();
                }
            }
        });
    }
);
